import { LazyLoadImage } from 'react-lazy-load-image-component';
import defaultImg from './default-img.svg';
import defaultHead from './default-head.svg';
import { CSSProperties, useEffect, useState } from 'react';
import styles from './index.module.scss';
import classNames from 'clsx';
import { useMap, useMountedState } from 'react-use';

export type LazyImageProps = {
  src: string | undefined;
  alt?: string;
  width?: number;
  height?: number;
  fillCenter?: boolean;
  objectFit?: CSSProperties['objectFit'];
  className?: string;
  onErrorReportKey?: string;
  isHead?: boolean;
  defaultImageClassName?: string;
  paddingTop?: number | string;
};
console.log(defaultImg);
export { defaultImg, defaultHead };

export default function LazyImage(props: LazyImageProps) {
  const {
    src,
    alt,
    height = 300,
    width = 300,
    fillCenter = false,
    objectFit,
    onErrorReportKey,
    isHead = false,
    defaultImageClassName,
    paddingTop,
  } = props;
  const isMounted = useMountedState();

  const [isImg, setIsImg] = useState(false);

  useEffect(() => {
    const checkImgExists = new Promise((resolve, reject) => {
      if (!src) {
        reject();
      }
      const ImgObj = new Image();
      ImgObj.src = src as string;
      ImgObj.onload = () => {
        resolve({
          w: ImgObj.width,
          h: ImgObj.height,
        });
      };
      ImgObj.onerror = (err) => {
        reject(err);
      };
    });
    checkImgExists
      .then((res: any) => {
        if (!isMounted()) {
          return;
        }
        setIsImg(true);
      })
      .catch((_err) => {
        if (isMounted()) {
          setIsImg(false);
        }
      });
  }, [src]);
  return (
    <div className={classNames([props.className])}>
      {src && isImg ? (
        <LazyLoadImage
          alt={alt}
          width={width}
          height={height}
          effect="blur"
          src={src}
          placeholderSrc={isHead ? defaultHead : defaultImg}
          style={{
            objectFit,
            borderRadius: '12px',
          }}
        />
      ) : (
        <div
          style={{
            height,
            width,
            background:
              'linear-gradient(180deg,rgba(35,30,33,.8),rgba(21,25,28,.99)),#171a1e',
          }}
          className="flex items-center justify-center"
        >
          {isHead ? defaultHead() : defaultImg()}
        </div>
      )}
    </div>
  );
}
